<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <ShowcaseOffersApproval
                        v-if="offer.siteName"
                        :offer-name="offer.siteName"
                        :param-name="offer.params.approval?.name"
                        :param-value="offer.params.approval?.string"
                    />
                    <div class="lds-widget-card__params">
                        <div
                            class="lds-widget-card__block"
                            v-if="offer.params.creditLimit || offer.params.rate"
                        >
                            <ShowcaseOfferParams
                                v-if="offer.params.creditLimit"
                                :name="offer.params.creditLimit.name"
                                :value="offer.params.creditLimit.string"
                                class="lds-widget-card__item_credit-limit"
                                :symbol="currencySymbol"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.rate"
                                :name="offer.params.rate.name"
                                :value="offer.params.rate.string"
                                class="lds-widget-card__item_rate"
                                symbol="%"
                            />
                        </div>
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.freePeriod"
                                :name="offer.params.freePeriod.name"
                                :value="offer.params.freePeriod.string"
                                class="lds-widget-card__item_free-period"
                                symbol="дн."
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.maintenance"
                                :name="offer.params.maintenance.name"
                                :value="offer.params.maintenance.string"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import { inject } from 'vue';
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
import ShowcaseOffersApproval from '../ShowcaseOfferParams/ShowcaseOffersApproval.vue';
// import { cookieStore } from '@/scripts/cookie.ts';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const currencySymbol = inject('currencySymbol');
const { offerClasses } = showcaseOfferClasses(props);

function transformUrl(url) {
    return cookieStore.transformUrl(url);
}

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>